import {useEffect, useState} from "react"

import "../../page/Test/Test.css"
import closeBtn from "../../assets/mobileClose.svg"

import CheckModal from "../../component/Modal/CheckModal"
import App from "../../App";
import app from "../../App";
import {retrieveData, sendRequest, validateEmail, validatePhone} from "../../common";
import {useNavigate} from "react-router-dom";


export const ApplyTest = ({product, applyTest, index, onSelected, onChange, selected}) => {

	const [name, setName] = useState()
	const [birth, setBirth] = useState()
	const [applyNumber, setApplyNumber] = useState()
	const [organization, setOrganization] = useState()
	const [email, setEmail] = useState()
	const [phone, setPhone] = useState()
	const [group, setGroup] = useState('일반 성인')

	useEffect(() => {
		onChange({
			product,
			name,
			birth,
			applyNumber,
			organization,
			email,
			phone,
			group
		}, index)
	}, [name, birth, applyNumber, organization, email, phone, group])

	useEffect(() => {
		setName(applyTest?.name)
		setBirth(applyTest?.birth)
		setApplyNumber(applyTest?.applyNumber)
		setOrganization(applyTest?.organization)
		setEmail(applyTest?.email)
		setPhone(applyTest?.phone)
		setGroup(applyTest?.group)

		onChange({
			product,
			name: applyTest?.name,
			birth: applyTest?.birth,
			applyNumber: applyTest?.applyNumber,
			organization: applyTest?.organization,
			email: applyTest?.email,
			phone: applyTest?.phone,
			group: applyTest?.group
		}, index)

	}, [applyTest])

	return (
		<tr key={index}>
			<td>
				<div className="formCheckbox">
					<input type="checkbox" id={`tableSelect${index}`} required checked={selected?.indexOf(index) !== -1} onChange={e => onSelected(e.target.checked, index)}/>
					<label htmlFor={`tableSelect${index}`}></label>
				</div>
			</td>
			<td>{product?.name}</td>
			<td>
				<span>
					<input type="text" name="" placeholder="필수 항목" required value={name} onChange={e => setName(e.target.value)} />
				</span>
			</td>
			<td>
				<span>
					<input type="text" name="" pattern={'[0-9]'} placeholder="19930101" value={birth} onChange={e => setBirth(e.target.value.replace(/[^\d]/,''))} maxLength={8}/>
				</span>
			</td>
			<td>
				<span>
					<input type="text" name="" placeholder="비필수 항목"  value={applyNumber} onChange={e => setApplyNumber(e.target.value)} />
				</span>
			</td>
			<td>
				<span>
					<input type="text" name="" placeholder="비필수 항목"  value={organization} onChange={e => setOrganization(e.target.value)} />
				</span>
			</td>
			<td>
				<span>
					<input type="text" name="" placeholder="필수 항목" required  value={email} onChange={e => setEmail(e.target.value)} onBlur={() => validateEmail(email, setEmail)}/>
				</span>
			</td>
			<td>
				<span>
					<input type="text" name="" placeholder="필수 항목" required  value={phone} onChange={e => setPhone(e.target.value)} onBlur={() => validatePhone(phone, setPhone)} maxLength={12}/>
				</span>
			</td>
			<td>
				<span>
					<select name="" value={group} onChange={e => {
						setGroup(e.target.value)
					}}>
						<option defaultValue="">일반 성인</option>
						<option defaultValue="">대학생</option>
						<option defaultValue="">고등학생</option>
						<option defaultValue="">중학생</option>
						<option defaultValue="">초등학생</option>
					</select>
				</span>
			</td>
		</tr>
	)
}


function PersonalCreate({product}) {

	const navigate = useNavigate()
	const [user, setUser] = useState()

	useEffect(() => {
		retrieveData('user').then(user => {
			setUser(user)
		})
	}, [])

	const [checkOpen, setCheckOpen] = useState(false)
	const showCheck = () => {
		setCheckOpen(true)
	}

	const [notiOpen, setNotiOpen] = useState(false)
	const showNoti = () => {
		setNotiOpen(true)
	}
	const closeNoti = () => {
		setNotiOpen(false)
	}

	const [applyTests, setApplyTests] = useState([{group: '일반 성인'}])
	const [selected, setSelected] = useState([])

	const increaseApplyTests = () => {
		if (applyTests?.length >= product?.remainCash) {
			alert(`남은 캐시 수 만큼만 목록을 추가할 수 있습니다.`)
			return
		}
		setApplyTests(applyTests.concat({group: '일반 성인'}))
	}

	const deleteApplyTest = (index) => {
		applyTests.splice(index,1)
		setApplyTests(Object.assign([], applyTests))
	}

	const deleteSelected = () => {
		selected.map(item => deleteApplyTest(item))
	}

	const onSelected = (checked, index) => {
		if (checked) {
			selected.push(index)
			setSelected(Object.assign([], selected))
		} else {
			const idx = selected.indexOf(index)
			if (idx !== -1) {
				selected.splice(idx, 1)
				setSelected(Object.assign([], selected))
			}
		}
	}

	const onChange = (applyTest, index) => {
		applyTests[index] = applyTest
		setApplyTests(applyTests)
	}

	const isValid = () => {
		if (applyTests?.filter((item, index) => selected.indexOf(index) !== -1).filter(item => !item?.name?.length || !item?.email?.length || !item?.phone?.length || !item?.group?.length)?.length) {
			return false
		}
		return true
	}

	const saveAllApplyTests = () => {
		saveApplyTest(applyTests?.filter((item, index) => selected.indexOf(index) !== -1), 0)
	}

	const saveApplyTest = (applyTests, index) => {
		if (applyTests?.length - 1 < index) {
			setCheckOpen(false)
			alert('모두 생성 되었습니다.')
			navigate('/personal-code/send-waiting')
			return
		}

		sendRequest('test/apply-test/', 'POST', {
			...applyTests[index],
			sender: user?.id,
			test: product?.test?.id,
			product: product?.id
		}, data => {
			saveApplyTest(applyTests, index + 1)
		})
	}

	return (
		<>
			<section className="personalCreate">
				<form name="personalCreate">
					<div className="tableTab">
						<div className="tableBtn">
							<button type="button" className="addBtn" onClick={increaseApplyTests}>목록 추가</button>
							<button type="button" onClick={deleteSelected}>선택 삭제</button>
						</div>
						<span>총 {selected?.length}명</span>
					</div>
					<div className="testTableWrap">
						<table className="testTable">
							<colgroup>
								<col width="5%" />
								<col width="15%" />
								<col width="10%" />
								<col width="10%" />
								<col width="15%" />
								<col width="10%" />
								<col width="15%" />
								<col width="10%" />
								<col width="10%" />
							</colgroup>
							<thead>
								<tr>
									<th>
										<div className="formCheckbox">
											<input type="checkbox" id="tableSelectAll" required
														 onChange={e => {
															 if (e.target.checked) {
																 setSelected(applyTests?.map((item, index) => index))
															 } else {
																 setSelected([])
															 }
														 }}
											/>
											<label htmlFor="tableSelectAll"></label>
										</div>
									</th>
									<th>검사종류</th>
									<th>
										이름 <span className="required">*</span>
									</th>
									<th>생년월일</th>
									<th>개인고유번호</th>
									<th>소속기관</th>
									<th>
										이메일 <span className="required">*</span>
									</th>
									<th>
										휴대폰 번호 <span className="required">*</span>
									</th>
									<th>
										규준집단 <span className="required">*</span>
									</th>
								</tr>
							</thead>
							<tbody>
								{applyTests?.map((item, index) => {
									return (
										<ApplyTest key={index} product={product} applyTest={item} index={index} onSelected={onSelected} onChange={onChange} selected={selected}/>
									)
								})}
							</tbody>
						</table>
					</div>
					<div className="testBtnWrap">
						<button type="button" onClick={showNoti}>
							취소
						</button>
						<button type="button" onClick={() => {
							if (!isValid()) {
								alert('필수값을 모두 채워주세요.')
							} else if (!selected?.length) {
								alert('생성할 항목을 선택해 주세요.')
							} else {
								showCheck()
							}

						}} className="keyBtn">
							생성하기
						</button>
					</div>
				</form>
			</section>

			{checkOpen && (
				<CheckModal
					setCheckOpen={setCheckOpen}
					warning={`총 ${selected?.length}건의 인증코드를 생성 하시겠습니까?`}
					text={"인증코드 생성 시에는 캐시가 차감되지 않습니다."}
					onConfirm={saveAllApplyTests}
				/>
			)}

			{notiOpen && (
				<div className="notiWrap">
					<div className="notiModal">
						<div className="modalHeader">
							<h2>알림</h2>
							<button type="button" onClick={closeNoti}>
								<img src={closeBtn} alt="팝업 닫기" />
							</button>
						</div>
						<div className="modalText">
							코드 생성을 위한 <span className="blue">잔여캐시</span>가 부족하므로 <br />
							구매 후 목록 추가 해주시기 바랍니다.
						</div>
						<div className="modalBtn">
							<button type="button" onClick={closeNoti}>
								확인 (닫기)
							</button>
						</div>
					</div>
				</div>
			)}

		</>
	)
}

export default PersonalCreate
